var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "special_radio" },
    [
      _c("div", { staticClass: "title_h1" }, [_vm._v("日程回答")]),
      _c(
        "vab-collapse-info",
        { attrs: { disabled: !_vm.isSave } },
        [
          _c("template", { slot: "title" }, [
            _vm._v(
              " " +
                _vm._s(_vm.getFieldValue("demandBaseIdModel.title", _vm.info)) +
                "［" +
                _vm._s(_vm.getFieldValue("acceptOrderNo", _vm.info)) +
                "］ "
            ),
          ]),
          _vm.showDownLoad
            ? _c("template", { slot: "upload" }, [
                _c(
                  "div",
                  {
                    staticClass: "flex_center_align",
                    class: { disabled_file_name: !_vm.isSave },
                    on: { click: _vm.downLoadDateFile },
                  },
                  [
                    _c("span", { staticClass: "file_name" }, [
                      _vm._v("見積情報ダウンロード"),
                    ]),
                    _c("svg-icon", {
                      staticClass: "upload_svg arrow",
                      attrs: { "icon-class": "download_2_line" },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c("template", { slot: "link" }, [_vm._v("発注変更")]),
          _c(
            "template",
            { slot: "row" },
            [
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("建物")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 20 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "buildingCdModel.blgsnmkj",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("商品")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "demandBaseIdModel.itemCdModel.itmnm",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("商品明細")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box center_box", attrs: { span: 8 } },
                    _vm._l(_vm.mitmdtlpModelList, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "flex_space width_100" },
                        [
                          _c("div", [
                            _vm._v(
                              " " +
                                _vm._s(_vm.getFieldValue("itmdtlnm", item)) +
                                " "
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("依頼件名")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 20 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "requestIdModel.constructionName",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("案件分類")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getEnumText(
                              _vm.getFieldValue(
                                "demandBaseIdModel.businessForm",
                                _vm.info
                              ),
                              _vm.$divisions.consignmentWorkClassEnum
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("依頼区分")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getEnumText(
                              _vm.getFieldValue(
                                "requestIdModel.requestClass",
                                _vm.info
                              ),
                              _vm.$divisions.requestClassEnum
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("進行部門")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "demandBaseIdModel.progressDepCdModel.orgkjrn",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("進行担当者")]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "word_box center_box", attrs: { span: 8 } },
                    _vm._l(
                      _vm.getFieldValue(
                        "demandBaseIdModel.demandChargePersonModelList",
                        _vm.info
                      ),
                      function (item, index) {
                        return _c("div", { key: index }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.getFieldValue(
                                  "empnmkj",
                                  item.chargePersonCdModel
                                )
                              ) +
                              " "
                          ),
                        ])
                      }
                    ),
                    0
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("日程調整状況")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getEnumText(
                              _vm.info.adjScheduleStatus,
                              _vm.$divisions.adjScheduleStatusEnum
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("日程回答期限")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "requestIdModel.scheduleLimitDate",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("書類提出期限")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 8 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "requestIdModel.docLimitDate",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _vm.isEqualCodeEnum(
                    _vm.getFieldValue("requestIdModel.requestClass", _vm.info),
                    _vm.$divisions.requestClassEnum.enum_1
                  )
                    ? [
                        _c(
                          "vab-col",
                          { staticClass: "title_box", attrs: { span: 4 } },
                          [_vm._v("事前調査要否")]
                        ),
                        _c(
                          "vab-col",
                          {
                            staticClass: "word_box flex_center_align",
                            attrs: { span: 8 },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getEnumText(
                                    _vm.getFieldValue(
                                      "requestIdModel.investigationFlg",
                                      _vm.info
                                    ),
                                    _vm.$divisions.investigationFlgEnum
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    : [
                        _c(
                          "vab-col",
                          { staticClass: "title_box", attrs: { span: 4 } },
                          [_vm._v("土日休工要否")]
                        ),
                        _c(
                          "vab-col",
                          {
                            staticClass: "word_box flex_center_align",
                            attrs: { span: 8 },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getEnumText(
                                    _vm.getFieldValue(
                                      "requestIdModel.weekdayClosedFlg",
                                      _vm.info
                                    ),
                                    _vm.$divisions.necessaryFlagEnum
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                ],
                2
              ),
              _c(
                "vab-row",
                { staticClass: "row_box" },
                [
                  _c(
                    "vab-col",
                    { staticClass: "title_box", attrs: { span: 4 } },
                    [_vm._v("工事内容")]
                  ),
                  _c(
                    "vab-col",
                    {
                      staticClass: "word_box flex_center_align",
                      attrs: { span: 20 },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.getFieldValue(
                              "requestIdModel.constructionDetail",
                              _vm.info
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "info_main new_workInfo" },
        [
          _c(
            "div",
            {
              staticClass: "head_box flex_start flex_center_align",
              staticStyle: { "padding-top": "12px" },
            },
            [
              _c("svg-icon", { attrs: { "icon-class": "edit_2_line" } }),
              _c("span", { staticClass: "hd_title" }, [_vm._v("日程調整")]),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "h_date flex_center_align" },
            [
              _c("svg-icon", {
                staticClass: "h_svg",
                attrs: { "icon-class": "tryangle_down" },
              }),
              _c("span", { staticClass: "h_title h_img_none" }, [
                _vm._v("候補日程を登録してください"),
              ]),
            ],
            1
          ),
          _c(
            "vab-form",
            { ref: "form", attrs: { model: _vm.form, rules: _vm.rules } },
            [
              _c(
                "div",
                { staticClass: "sure_box top_info mtn" },
                [
                  _vm.checkEnumFlag(
                    _vm.getFieldValue("requestIdModel.requestClass", _vm.info)
                  )
                    ? _c(
                        "vab-row",
                        { staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("対応判断")]
                          ),
                          _c(
                            "vab-col",
                            {
                              staticClass: "word_box flex_center_align pdtb8",
                              attrs: { span: 20 },
                            },
                            [
                              _c("vab-radio-group", {
                                ref: "dealingFlgRef",
                                attrs: {
                                  label: "",
                                  "label-width": "0",
                                  prop: "dealingFlg",
                                  filter: "dealingFlg",
                                  disabled: _vm.dealingDisable,
                                },
                                on: { change: _vm.disableWattingList },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isEqualCodeEnum(
                    _vm.getFieldValue("requestIdModel.requestClass", _vm.info),
                    _vm.$divisions.requestClassEnum.enum_2
                  ) &&
                  _vm.isEqualCodeEnum(
                    _vm.getFieldValue("demandType", _vm.info),
                    _vm.$divisions.demandTypeEnum.enum_2
                  )
                    ? _c(
                        "vab-row",
                        { staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("報告書提出予定月")]
                          ),
                          _c(
                            "vab-col",
                            {
                              staticClass: "word_box flex_center_align pdtb8",
                              attrs: { span: 20 },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "tz_right w140" },
                                [
                                  _c("vab-date-picker", {
                                    attrs: {
                                      type: "month",
                                      "label-show": false,
                                      "value-format": "yyyy/MM/01",
                                      format: "yyyy/MM",
                                      prop: "reportSubmitYearMonth",
                                      disabled: _vm.dealingDisable,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.form.scheduleAdjDetailModelList.length > 0
                    ? _c(
                        "div",
                        [
                          _vm._l(
                            _vm.form.scheduleAdjDetailModelList,
                            function (row, index) {
                              return [
                                row.show
                                  ? _c(
                                      "vab-row",
                                      { key: index, staticClass: "row_box" },
                                      [
                                        _c(
                                          "vab-col",
                                          {
                                            staticClass: "title_box",
                                            attrs: { span: 4 },
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "flex_colum" },
                                              [
                                                _c("div", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.getSecTitile(
                                                        row,
                                                        index + 1
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "clear_btn",
                                                    class:
                                                      _vm.dealingDisable ||
                                                      _vm.dealingFlgData
                                                        ? "disabledBtn "
                                                        : "",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.clear(index)
                                                      },
                                                    },
                                                  },
                                                  [_vm._v(" クリア ")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "vab-col",
                                          {
                                            staticClass: "word_box nopadding",
                                            attrs: { span: 20 },
                                          },
                                          [
                                            _c(
                                              "vab-row",
                                              {
                                                staticClass:
                                                  "flex_center_align pdtb8",
                                              },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "line_boder margin_8",
                                                }),
                                                _c(
                                                  "vab-col",
                                                  {
                                                    staticClass:
                                                      "flex_center_align picker_label",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "tz_title",
                                                      },
                                                      [_vm._v("日程")]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "vab-col",
                                                  {
                                                    staticClass:
                                                      "date_picker width_auto",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex_start tz_right flex_center_align",
                                                      },
                                                      [
                                                        _c("vab-date-picker", {
                                                          attrs: {
                                                            type: "date",
                                                            "label-show": false,
                                                            "value-format":
                                                              "yyyy/MM/dd",
                                                            format:
                                                              "yyyy/MM/dd",
                                                            validate:
                                                              _vm.vaildateTimeStart(
                                                                row,
                                                                index
                                                              ),
                                                            prop:
                                                              "scheduleAdjDetailModelList." +
                                                              index +
                                                              ".startDateTime",
                                                            "end-date-prop":
                                                              "scheduleAdjDetailModelList." +
                                                              index +
                                                              ".endDateTime",
                                                            disabled:
                                                              row.timeDisabled,
                                                            clearable: false,
                                                          },
                                                          on: {
                                                            change: function (
                                                              value
                                                            ) {
                                                              return _vm.changeWattingDate(
                                                                row,
                                                                index,
                                                                value,
                                                                "startDateTime"
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "line",
                                                          },
                                                          [_vm._v("～")]
                                                        ),
                                                        _c("vab-date-picker", {
                                                          attrs: {
                                                            type: "date",
                                                            "label-show": false,
                                                            "value-format":
                                                              "yyyy/MM/dd",
                                                            format:
                                                              "yyyy/MM/dd",
                                                            validate:
                                                              _vm.vaildateTimeEnd(
                                                                row,
                                                                index
                                                              ),
                                                            prop:
                                                              "scheduleAdjDetailModelList." +
                                                              index +
                                                              ".endDateTime",
                                                            "start-date-prop":
                                                              "scheduleAdjDetailModelList." +
                                                              index +
                                                              ".startDateTime",
                                                            disabled:
                                                              row.timeDisabled,
                                                            clearable: false,
                                                          },
                                                          on: {
                                                            change: function (
                                                              value
                                                            ) {
                                                              return _vm.changeWattingDate(
                                                                row,
                                                                index,
                                                                value,
                                                                "endDateTime"
                                                              )
                                                            },
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "vab-row",
                                              { staticClass: "margin_8" },
                                              [
                                                _c(
                                                  "vab-col",
                                                  {
                                                    staticClass:
                                                      "flex_center_align picker_label",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "tz_title",
                                                      },
                                                      [_vm._v("時間")]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "vab-col",
                                                  {
                                                    staticClass: "time_picker",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "flex_start flex_center_align",
                                                      },
                                                      [
                                                        _c("vab-time-picker", {
                                                          attrs: {
                                                            prop:
                                                              "scheduleAdjDetailModelList." +
                                                              index +
                                                              ".startTime",
                                                            format: "HH:mm",
                                                            "value-format":
                                                              "HH:mm",
                                                            "value-format-sss": true,
                                                            disabled:
                                                              row.disabled,
                                                            "end-date-prop":
                                                              "scheduleAdjDetailModelList." +
                                                              index +
                                                              ".endTime",
                                                          },
                                                          on: {
                                                            change: function (
                                                              value
                                                            ) {
                                                              return _vm.changeWattingTime(
                                                                row
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "line",
                                                          },
                                                          [_vm._v("～")]
                                                        ),
                                                        _c("vab-time-picker", {
                                                          attrs: {
                                                            prop:
                                                              "scheduleAdjDetailModelList." +
                                                              index +
                                                              ".endTime",
                                                            format: "HH:mm",
                                                            "value-format":
                                                              "HH:mm",
                                                            "value-format-sss": true,
                                                            disabled:
                                                              row.disabled,
                                                            "start-date-prop":
                                                              "scheduleAdjDetailModelList." +
                                                              index +
                                                              ".startTime",
                                                          },
                                                          on: {
                                                            change: function (
                                                              value
                                                            ) {
                                                              return _vm.changeWattingTime(
                                                                row
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "end_box",
                                                          },
                                                          [
                                                            _c("vab-checkbox", {
                                                              ref:
                                                                "dayFlagRef" +
                                                                index,
                                                              refInFor: true,
                                                              class:
                                                                row.checkDisabled
                                                                  ? "checkbox_disabled"
                                                                  : "",
                                                              attrs: {
                                                                label: "終日",
                                                                prop:
                                                                  "scheduleAdjDetailModelList." +
                                                                  index +
                                                                  ".dayFlag",
                                                                "code-enum":
                                                                  _vm.$divisions
                                                                    .validFlgEnum,
                                                                disabled:
                                                                  row.checkDisabled,
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    value
                                                                  ) {
                                                                    return _vm.changeDayFlag(
                                                                      value,
                                                                      row
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            }
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "vab-collapse",
                    {
                      staticClass: "message_collapse",
                      attrs: { title: "カレンダーを閉じる", dot: true },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "los_box" },
                        [_c("vab-calendar", { ref: "calendar" })],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "file_box norborder m7" },
                    [
                      _vm.isEqualCodeEnum(
                        _vm.info.demandType,
                        _vm.$divisions.demandTypeEnum.enum_3
                      ) && _vm.fileList.length > 0
                        ? _c(
                            "vab-row",
                            { staticClass: "row_box" },
                            [
                              _c(
                                "vab-col",
                                {
                                  staticClass: "title_box",
                                  attrs: { span: 4 },
                                },
                                [
                                  _c("div", { staticClass: "flex_colum" }, [
                                    _c("div", { staticClass: "gyzl" }, [
                                      _vm._v("共有資料"),
                                    ]),
                                  ]),
                                ]
                              ),
                              _c(
                                "vab-col",
                                {
                                  staticClass:
                                    "common_data_file word_box border_left_none",
                                  attrs: { span: 20 },
                                },
                                [
                                  _vm.fileList.length > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "common_data_file_box" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "inner_box common_data_file_box",
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "word_col_upload_filebox",
                                                },
                                                _vm._l(
                                                  _vm.fileList,
                                                  function (item, f) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: f,
                                                        staticClass:
                                                          "file_inner_item flex_start pl0",
                                                        class: {
                                                          disabled_file_name:
                                                            _vm.disabledFileName(
                                                              item
                                                            ),
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "arrow_box",
                                                          },
                                                          [
                                                            _c("svg-icon", {
                                                              staticClass:
                                                                "arrow",
                                                              attrs: {
                                                                "icon-class":
                                                                  "tryangle_right",
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "file_name_out_box",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "flex_colum file_name_box",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "file_name",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.downLoadFile(
                                                                            item
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          item.fileName
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "file_time",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " アップロード日時：" +
                                                                        _vm._s(
                                                                          item.createDate
                                                                        ) +
                                                                        " " +
                                                                        _vm._s(
                                                                          _vm.formatTimeMsel(
                                                                            item.createTime
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "vab-row",
                                    {
                                      staticClass: "bj20",
                                      staticStyle: { "margin-top": "20px" },
                                    },
                                    [
                                      _c(
                                        "vab-col",
                                        {
                                          staticClass: "pt10",
                                          attrs: { span: 1 },
                                        },
                                        [_vm._v("備考")]
                                      ),
                                      _c(
                                        "vab-col",
                                        {
                                          staticClass: "nopadding2",
                                          attrs: { span: 23 },
                                        },
                                        [
                                          _c("vab-textarea", {
                                            attrs: {
                                              type: "textarea",
                                              prop: "toPartnerFilesRemarks",
                                              rows: "5",
                                              maxlength: "1170",
                                              disabled: true,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "vab-row",
                        { staticClass: "row_box" },
                        [
                          _c(
                            "vab-col",
                            { staticClass: "title_box", attrs: { span: 4 } },
                            [_vm._v("協力会社コメント")]
                          ),
                          _c(
                            "vab-col",
                            {
                              staticClass: "word_box nopadding2 pdtb8",
                              attrs: { span: 20 },
                            },
                            [
                              _c("vab-textarea", {
                                attrs: {
                                  type: "textarea",
                                  prop: "submitRemarks",
                                  rows: "5",
                                  maxlength: "1170",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("vab-message", {
                    staticClass: "change_box nomargin detail_nopadding",
                    attrs: {
                      title: "コメント履歴を閉じる",
                      "msg-type":
                        _vm.$divisions.adjSourceClassEnum.enum_1.value,
                      "msg-id": _vm.$route.query.requestDetailId,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "flex_end mg12" },
            [_c("vab-button", { attrs: { "btn-list": _vm.btnList } })],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }